import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { ISRResponse } from '_core/types';
import { UpdateMemberSensitiveDataTypes } from '../Types';

const machine = Machines.onUpdateMemberSensitiveData.machine;

export const updateMemberSensitiveData = (
  params: UpdateMemberSensitiveDataTypes.UpdateMemberSensitiveDataServiceRequestType,
): Promise<ISRResponse> => {
  return callServiceMachine(machine, params);
};

export default { updateMemberSensitiveData };
